import ChannelMessage from './ChannelMessage'
export default ChannelMessage
